/**
 * 数学乘法。
 *
 * @category Mathematics
 *
 * @public
 *
 * @param value - 被乘数。
 * @param operand - 乘数。
 *
 * @returns 积。
 */
export function multiply(value, operand) {
    return value * operand;
}
//# sourceMappingURL=multiply.js.map